"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTermsSaveMapper = void 0;
var PaymentTermsSaveMapper = /** @class */ (function () {
    function PaymentTermsSaveMapper(data) {
        this.localData = data;
    }
    PaymentTermsSaveMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return PaymentTermsSaveMapper;
}());
exports.PaymentTermsSaveMapper = PaymentTermsSaveMapper;
//# sourceMappingURL=PaymentTermsSaveMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/PaymentTermsSaveMapper.js
// module id = 2067
// module chunks = 8